const HASH_KEY1 = 'fg_2024';
const HASH_KEY2 = 'bg_2025';
const HASH_KEY3 = 'grid_2026';

function hashCode(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return Math.abs(hash);
}

function colorGen(input: string): string {
    const hash = hashCode(input);
    const hue = hash % 360;
    const saturation = 65 + (hash % 20);
    const lightness = 45 + (hash % 20);
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

function bitmapGen(input: string, size: number = 5): number[] {
    const hash = hashCode(input);
    const grid: number[] = [];
    const halfSize = Math.floor(size / 2);
    
    for (let y = 0; y < size; y++) {
        for (let x = 0; x < halfSize; x++) {
            const index = y * halfSize + x;
            const bit = (hash >> index) & 1;
            grid[y * size + x] = bit;
            grid[y * size + (size - 1 - x)] = bit;
        }
        if (size % 2 === 1) {
            const centerIndex = y * size + halfSize;
            grid[centerIndex] = (hash >> (y + halfSize * size)) & 1;
        }
    }
    
    return grid;
}

export function generateIdenticon(userId: string): { fgColor: string; bgColor: string; grid: number[] } {
    const fgColor = colorGen(userId + HASH_KEY1);
    const bgColor = colorGen(userId + HASH_KEY2);
    const grid = bitmapGen(userId + HASH_KEY3);
    
    return { fgColor, bgColor, grid };
}

export function identiconToSvg(identicon: { fgColor: string; bgColor: string; grid: number[] }, size: number = 200, isCircular: boolean = false): string {
    const gridSize = Math.sqrt(identicon.grid.length);
    const padding = size * 0.1;
    const actualSize = size - padding * 2;
    const actualCellSize = actualSize / gridSize;
    
    let rects = '';
    for (let i = 0; i < identicon.grid.length; i++) {
        if (identicon.grid[i] === 1) {
            const x = (i % gridSize) * actualCellSize + padding;
            const y = Math.floor(i / gridSize) * actualCellSize + padding;
            rects += `<rect x="${x}" y="${y}" width="${actualCellSize}" height="${actualCellSize}" fill="${identicon.fgColor}" />`;
        }
    }
    
    const maskId = `mask-${Math.random().toString(36).substr(2, 9)}`;
    
    return `
        <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
            ${isCircular ? `
                <defs>
                    <mask id="${maskId}">
                        <rect width="${size}" height="${size}" fill="black" />
                        <circle cx="${size/2}" cy="${size/2}" r="${size/2}" fill="white" />
                    </mask>
                </defs>
                <g mask="url(#${maskId})">
            ` : ''}
            <rect width="${size}" height="${size}" fill="${identicon.bgColor}" />
            ${rects}
            ${isCircular ? '</g>' : ''}
        </svg>
    `;
}